import { useGetNotificationSettings, useUpdateNotificationSettings } from './useNotificationSettings'

export {
  SLACK_CHANNEL_NOT_FOUND,
  type NotificationSettingsErrorResponse,
  type OrganizationNotificationSettings,
} from './useNotificationSettings'

export const notificationSettings = {
  get: useGetNotificationSettings,
  update: useUpdateNotificationSettings,
}
